import {FC} from 'react';
import {COLORS, MAX_WIDTH} from '../../design';

interface AppContentProps {
  children?: React.ReactNode;
}

export const AppContent: FC<AppContentProps> = ({children}) => {
  return (
    <div style={{flex: '1 1 auto'}}>
      <div
        className="app-content-container"
        style={{
          maxWidth: MAX_WIDTH,
        }}
      >
        <div className="app-content" style={{}}>
          {children}
        </div>
      </div>
    </div>
  );
};
